import { Amplify } from "aws-amplify";

// Publieke Cognito-config (admin-pool). Pool/client-id zijn geen secrets.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || "eu-central-1_JuyxsF9Vp",
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || "29kdb2fe0n3jmon8125s5l8rqi",
    },
  },
});
